/* eslint-disable react/jsx-curly-newline */
import React, { PureComponent } from 'react';
import { FormattedTag, FormattedHTMLMessageSecure } from 'core/components';
import { Main } from 'components/main/main';
import { HeadHelmet } from 'components/head-helmet/head-helmet';

import { PAGE_NAMES } from '../../constants';

class License extends PureComponent {
  render() {
    return (
      <Main className="text-markup-container license-page">
        <Main className="text-markup-container">
          <HeadHelmet page={PAGE_NAMES.LICENSE} />

          <div className="text-markup-inner">
            <FormattedTag
              tag="h1"
              id="license.title"
              className="text-markup-title"
            />

            <div className="text-markup-content text-white-75">
              <FormattedHTMLMessageSecure id="license.content" />
              <FormattedHTMLMessageSecure id="license.content2" />
            </div>
          </div>
        </Main>
      </Main>
    );
  }
}

export default License;
